import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { hasMenuAccess, menuKeyForPath } from '../../util/menuAccess';

const MenuAccessGuard = ({ children }: { children: JSX.Element }) => {
  const { user } = useContext(AuthContext);
  const { pathname } = useLocation();
  const menuKey = menuKeyForPath(pathname);
  if (user && menuKey && !hasMenuAccess(user, menuKey)) return <Navigate to="/unauthorized" replace />;
  return children;
};

export default MenuAccessGuard;
